import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import authentication from "./plugins/keycloak";
import Notify from "./components/notify/Notify";
import VueSweetalert2 from "vue-sweetalert2";
import VuetifyMoney from "vuetify-money";
// import canDirective from "./util/directives/can";
import canDirective from "./util/directives/can";
import maskCnpj from "./util/directives/maskCnpj";
import Auth from "./services/http/auth/Auth";
import "./assets/style/sweetalert2.scss";
import { permissions } from "./store/permissionsStore";
import { createPinia } from "pinia";

Vue.config.productionTip = false;

Vue.use(authentication);
Vue.use(VueSweetalert2);
Vue.use(VuetifyMoney);
Vue.use(Notify);
Vue.use(createPinia());
Vue.use(canDirective);
Vue.use(maskCnpj);
// Vue.directive("can", {
//   // When the bound element is inserted into the DOM...
//   inserted: function (el) {
//     // Focus the element
//     el.focus();
//   },
// });

Vue.filter("TitleCase", (value) => {
  return value
    ? value.toLowerCase().replace(/(?:^|\s|-)\S/g, (x) => x.toUpperCase())
    : "";
});

Vue.filter("MaskCnpj", (cnpj) => {
  return cnpj.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
    "$1.$2.$3/$4-$5"
  );
});

Vue.$keycloak
  .init({ checkLoginIframe: false, onLoad: "login-required" })
  .then(async (auth) => {
    if (auth) {
      const { data } = await Auth().store({});
      const storePermission = permissions();
      storePermission.setPermissions(data);
      // localStorage.setItem("permissions", JSON.stringify(data));
    }

    new Vue({
      router,
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");
  });
